// MUI Imports
import type { Theme } from '@mui/material';

const input: Theme['components'] = {
  MuiInputBase: {
    styleOverrides: {
      root: {
        lineHeight: 1.6,
        '&.MuiInput-underline': {
          '&:before': {
            borderColor: 'var(--mui-palette-primary-main)',
          },
          '&:not(.Mui-disabled, .Mui-error):hover:before': {
            borderColor: 'var(--mui-palette-action-active)',
          },
        },
        '&.Mui-disabled': {
          backgroundColor: 'var(--mui-palette-background-disabled)',
          border: 'none',
          '&:before, &:after': {
            border: 'none !important',
            borderBottom: 'none !important',
          },
        },
        '&.Mui-disabled .MuiInputAdornment-root, &.Mui-disabled .MuiInputAdornment-root > *':
          {
            color: 'var(--mui-palette-action-disabled)',
          },
      },
    },
  },
  MuiFilledInput: {
    styleOverrides: {
      root: {
        '&:before': {
          borderBottom: '1px solid var(--mui-palette-text-secondary)',
        },
        '&.Mui-disabled:before': {
          border: 'none',
        },
      },
    },
  },
  MuiOutlinedInput: {
    defaultProps: {
      size: 'small',
    },
    styleOverrides: {
      root: {
        '&:not(.Mui-focused):not(.Mui-error):not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline':
          {
            borderColor: 'var(--mui-palette-action-active)',
          },
        '&.Mui-disabled': {
          backgroundColor: 'var(--mui-palette-background-disabled)',
          border: 'none',
        },
        '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
      },
      input: ({ ownerState }) => ({
        height: ownerState.size === 'medium' ? '24px' : '20px',
        padding: ownerState.size === 'medium' ? '8px 12px' : '6px 12px',
        // A leading icon sits 4px from the text; trailing icons keep the full 12px.
        ...(ownerState.startAdornment ? { paddingLeft: '4px' } : {}),
        '& ~ .MuiOutlinedInput-notchedOutline': {
          borderColor: 'var(--mui-palette-divider)',
        },
      }),
    },
  },
  MuiInputAdornment: {
    styleOverrides: {
      root: {
        color: 'var(--mui-palette-text-primary)',
        '& i, & svg': {
          fontSize: '1.25rem',
        },
        '& *': {
          color: 'inherit !important',
        },
      },
      // The icon-to-text gap comes from the input's inline padding alone, so the adornment adds no margin of its own.
      // A leading icon only marks the field's purpose, so it is muted; trailing icons keep the colors their state gives them.
      positionStart: {
        marginRight: 0,
        color: 'var(--mui-palette-text-disabled)',
      },
      positionEnd: {
        marginLeft: 0,
      },
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        lineHeight: 1,
        letterSpacing: 'unset',
      },
    },
  },
};

export { input };
